import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { PrimitiveAtom, useAtomValue } from "jotai";
import { Planogram } from "src/components/Planogram/Planogram";
import { Box } from "src/elements";
import { getNewItemLabel } from "src/components/Planogram/common/planogramItemView";

import {
  DEFAULT_NOTCH_RULER_WIDTH,
  getPdfPlanogramWidth,
} from "src/components/Planogram/components/Ruler/PdfNotchRulers";
import { getDrawnRunWidth } from "src/components/Planogram/components/KonvaPlanogram/sceneProjection";

export const FirstPdfPage = ({
  pogAtom,
  scale,
  categoryName,
}: {
  pogAtom: PrimitiveAtom<Pog | null>;
  scale: number;
  categoryName?: string;
}) => {
  const pog = useAtomValue(pogAtom);

  if (!pog) {
    return null;
  }

  const totalWidth =
    getPdfPlanogramWidth(
      getDrawnRunWidth(pog.planogram),
      pog.planogram.bays.length,
      DEFAULT_NOTCH_RULER_WIDTH,
    ) * scale;

  return (
    <Box position="relative" width={`${totalWidth}px`} height="100%">
      <Planogram
        pogAtom={pogAtom}
        scaleX={scale}
        scaleY={scale}
        pdfMode={true}
        customItemLabelOnly={true}
        customLabelRule={getNewItemLabel}
        isPog={true}
        categoryName={categoryName}
      />
    </Box>
  );
};
